module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_major/uma_dir-eb12bb9c1de179ed896769c4bfadc2e2.gif";